export const SENDING_REQUEST = 'PERMISSIONGROUPSFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'PERMISSIONGROUPSFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'PERMISSIONGROUPSFORM_UPDATE_SUCCESS';
export const FAILURE = 'PERMISSIONGROUPSFORM_FAILURE';
export const RESET_FORM = 'PERMISSIONGROUPSFORM_RESET_FORM';
export const SET_VALUE = 'PERMISSIONGROUPSFORM_SET_VALUE';